/**
 * Indicator 컴포넌트
 * @description 페이지네이션 점. 현재 페이지만 길어진다. 페이지가 하나뿐이면 아무것도
 *   그리지 않는다 — 넘길 곳이 없는데 점을 보여줄 이유가 없다. 앱 DS `Indicator` 의 웹 포팅.
 * @example
 * <Indicator count={images.length} activeIndex={page} label="Banner" />
 */
import { memo } from "react";

import { INDICATOR_DOT_SIZE, indicatorStyles } from "./Indicator.styles";
import type { IndicatorProps } from "./Indicator.types";

/** 페이지가 둘 이상일 때만 의미가 있다 */
const MIN_COUNT = 2;

const Indicator = memo<IndicatorProps>(
  ({ count, activeIndex, label, testID }) => {
    if (count < MIN_COUNT) return null;

    return (
      <div
        className={indicatorStyles.root}
        role="progressbar"
        aria-label={label}
        aria-valuemin={1}
        aria-valuemax={count}
        aria-valuenow={activeIndex + 1}
        data-testid={testID}
      >
        {Array.from({ length: count }, (_, index) => (
          <span
            key={index}
            aria-hidden
            className={[
              indicatorStyles.dot,
              index === activeIndex ? indicatorStyles.dotActive : "",
            ].join(" ")}
            style={{ height: INDICATOR_DOT_SIZE, minWidth: INDICATOR_DOT_SIZE }}
          />
        ))}
      </div>
    );
  },
);

Indicator.displayName = "Indicator";

export default Indicator;
